import _extends from "@babel/runtime-corejs3/helpers/extends";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import React from 'react';
import PropTypes from 'prop-types';
import { get, noop } from 'lodash';
import { SelectField } from '@unite-us/ui';
import { PHONE_TYPE_OPTIONS } from './constants';
import './stylesheets/phoneTypeField.scss';
import enums from '../../../../../constants/enums';
var PhoneTypeField = function PhoneTypeField(props) {
  var _props$phoneFor = props.phoneFor,
    phoneFor = _props$phoneFor === void 0 ? 'contact' : _props$phoneFor,
    groupUser = props.groupUser;
  var options;
  if (phoneFor === 'program' || phoneFor === 'group') {
    options = PHONE_TYPE_OPTIONS;
  } else {
    var _context;
    options = groupUser ? _filterInstanceProperty(_context = get(enums, "".concat(phoneFor, "_data.phone_types"), [])).call(_context, function (phoneType) {
      return phoneType.value !== 'home';
    }) : get(enums, "".concat(phoneFor, "_data.phone_types"), []);
  }
  return /*#__PURE__*/React.createElement(SelectField, _extends({
    className: "phone-type-field"
  }, props, {
    options: options
  }));
};
PhoneTypeField.propTypes = {
  forceObjectValue: PropTypes.bool,
  groupUser: PropTypes.bool,
  hideLabel: PropTypes.bool,
  label: PropTypes.string,
  labelKey: PropTypes.string,
  phoneFor: PropTypes.oneOf(['contact', 'group', 'program']),
  placeholder: PropTypes.string,
  registerField: PropTypes.func,
  shouldSort: PropTypes.bool,
  valueKey: PropTypes.string
};
PhoneTypeField.defaultProps = {
  forceObjectValue: true,
  groupUser: false,
  hideLabel: true,
  label: 'Phone Type',
  labelKey: 'display_name',
  phoneFor: 'contact',
  placeholder: 'Phone Type',
  registerField: noop,
  shouldSort: false,
  valueKey: 'value'
};
export default PhoneTypeField;
//# sourceMappingURL=index.js.map